import Styles from "./index.module.scss";
import clsx from "clsx";
import { useMemo, useState, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select from "react-select";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { getMBValue } from "../../../Share/Func/Handle";
import { SwalError, SwalFail } from "../../../Share/Swal";
import { BsFillPlusSquareFill } from "react-icons/bs";
import { NEW_TYPES } from "../../../Constants/news";
import { CallApiUpLoadFile } from "../../../Api/Enforcement";

const MaxMB = 5;

const schema = yup.object().shape({
  title: yup.string().min(10, "Tiêu đề quá ngắn").required("Bắt buộc"),
  description: yup
    .string()
    .test(
      "min-length",
      "Yêu cầu tối thiểu 100 ký tự",
      (value) => value.length >= 100
    )
    .test(
      "max-length",
      `Không quá ${MaxMB}MB`,
      (value) => getMBValue(value) <= MaxMB
    )
    .required("Bắt buộc"),
  shortText: yup.string().required("Bắt buộc"),
  type: yup.object().required("Bắt buộc"),
});

export default function NewsForm({
  initialData,
  onSubmit,
  buttonText = "Cập nhật",
}) {
  const [img, setImg] = useState({
    imgUp: null,
    imgShow: "",
  });

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: useMemo(
      () => ({
        title: initialData?.Title || "",
        description: initialData?.Description || "",
        shortText: initialData?.shortText || "",
        type:
          NEW_TYPES.find((type) => type.value === initialData?.Type) ||
          NEW_TYPES[0],
      }),
      [initialData]
    ),
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    if (initialData) {
      reset({
        title: initialData.Title || "",
        description: initialData.Description || "",
        shortText: initialData.shortText || "",
        type:
          NEW_TYPES.find((type) => type.value === initialData.Type) ||
          NEW_TYPES[0],
      });

      if (initialData.Img) {
        setImg({
          imgUp: null,
          imgShow: process.env.REACT_APP_IMAGE_FOLDER + initialData.Img,
        });
      }
    }
  }, [initialData, reset]);

  const handleFileInputUpload = (event) => {
    const file = event.target.files[0];
    const allowed = ["image/jpeg", "image/png", "image/gif"];
    if (!allowed.includes(file.type)) return SwalFail("File không hợp lệ");

    const imageURL = URL.createObjectURL(file);
    setImg({ imgUp: file, imgShow: imageURL });
  };

  const handleSubmitForm = (data) => {
    if (!initialData && !img.imgUp) {
      SwalFail("Vui lòng chọn ảnh!");
      return;
    }

    if (!img.imgUp) {
      onSubmit(data, initialData?.Img || null);
      return;
    }

    const formData = new FormData();
    formData.append("", img.imgUp);

    CallApiUpLoadFile(formData, (res) => {
      if (res.Status) {
        SwalError(
          "Đã có lỗi xảy ra!\n Tải lại trang hoặc liên hệ để được hỗ trợ!"
        );
        return;
      }
      onSubmit(data, res);
    });
  };

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise(async (resolve, reject) => {
          try {
            const file = await loader.file;
            const formData = new FormData();
            formData.append("", file);
            CallApiUpLoadFile(formData, (res) => {
              if (res.Status) {
                SwalError(
                  "Đã có lỗi xảy ra!\n Tải lại trang hoặc liên hệ để được hỗ trợ!"
                );
                return;
              }
              console.log("res", res);
              const fileName = process.env.REACT_APP_IMAGE_FOLDER + res;
              resolve({
                default: fileName,
              });
            });
          } catch (error) {
            reject(error);
          }
        });
      },
      abort: () => {},
    };
  }
  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  // Update the CKEditor configuration
  const editorConfig = {
    toolbar: {
      items: [
        "heading",
        "|",
        "bold",
        "italic",
        "link",
        "|",
        "imageUpload",
        "insertTable",
        "mediaEmbed",
        "|",
      ],
    },
    image: {
      toolbar: [
        "imageStyle:inline",
        "imageStyle:block",
        "imageStyle:side",
        "|",
        "toggleImageCaption",
        "imageTextAlternative",
      ],
    },
    language: "en",
  };
  return (
    <form onSubmit={handleSubmit((data) => handleSubmitForm(data))}>
      <div className={clsx(Styles.mainWrap)}>
        <div className={clsx(Styles.row)}>
          <div className={clsx(Styles.btnBlock)}>
            <p className={clsx(Styles.note)}>Sao chép từ Word dán vào đây</p>
            <button type="submit" className={clsx(Styles.btn)}>
              {buttonText}
            </button>
          </div>

          <div className={clsx(Styles.listWrap)}>
            <div className={clsx(Styles.wrapBox)}>
              <div className={clsx(Styles.wrapTitle)}>
                <div className={clsx(Styles.title)}>
                  <label>Chọn ảnh</label>
                  <div className={clsx(Styles.wrapImg)}>
                    {img.imgShow ? (
                      <img src={img.imgShow} alt="ảnh" />
                    ) : (
                      <BsFillPlusSquareFill className={clsx(Styles.iconImg)} />
                    )}
                    <input
                      type="file"
                      onChange={handleFileInputUpload}
                      className={clsx(Styles.choseImg)}
                    />
                  </div>
                </div>

                <div className={clsx(Styles.title)}>
                  <label>Loại</label>
                  <Controller
                    name="type"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={NEW_TYPES}
                        value={field.value}
                        onChange={field.onChange}
                      />
                    )}
                  />
                  {errors.type && (
                    <p className={clsx(Styles.textDanger)}>
                      {errors.type.message}
                    </p>
                  )}
                </div>

                <div className={clsx(Styles.title)}>
                  <label>Tiêu đề</label>
                  <Controller
                    name="title"
                    control={control}
                    render={({ field }) => (
                      <>
                        <input
                          {...field}
                          placeholder="Nhập tiêu đề"
                          className={clsx(Styles.input)}
                        />
                        {errors.title && (
                          <p className={clsx(Styles.textDanger)}>
                            {errors.title.message}
                          </p>
                        )}
                      </>
                    )}
                  />
                </div>

                <div className={clsx(Styles.title)}>
                  <label>Miêu tả</label>
                  <Controller
                    name="shortText"
                    control={control}
                    render={({ field }) => (
                      <>
                        <textarea
                          {...field}
                          placeholder="Nhập mô tả"
                          className={clsx(Styles.input)}
                        />
                        {errors.shortText && (
                          <p className={clsx(Styles.textDanger)}>
                            {errors.shortText.message}
                          </p>
                        )}
                      </>
                    )}
                  />
                </div>
              </div>
            </div>

            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <CKEditor
                  editor={ClassicEditor}
                  data={field.value}
                  config={{
                    ...editorConfig,
                    extraPlugins: [uploadPlugin],
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    field.onChange(data);
                  }}
                  onError={(error, { willEditorRestart }) => {
                    console.error("CKEditor error:", error);
                    if (willEditorRestart) {
                      console.log("Editor will restart");
                    }
                  }}
                />
              )}
            />
            {errors.description && (
              <p className={clsx(Styles.textDanger)}>
                {errors.description.message}
              </p>
            )}
          </div>
        </div>
      </div>
    </form>
  );
}
